// extracted by mini-css-extract-plugin
module.exports = {"sectionContactSales":"ContactSales_sectionContactSales_1KfgZ","contactList":"ContactSales_contactList_RFMQJ"};